import img from './img';
import audio from './audio';
import dataConfig from './gameData.config.js';

var config = {
  author: 'MP',
  engine: 'createJS',
  gameConfig: dataConfig,
  title: [
    {
      text: 'Pomóż myszce dojść do komputera. Umieszczaj właściwe strzałki w odpowiednich polach metodą <i>złap, przesuń i upuść</i>.',
      audio: 'games/page007_game3/audio/z7c3.mp3',
    },
  ],
  checkGameSound: {
    positive: 'games/page007_game3/audio/z7c3-brawo.mp3',
    // negative: 'games/page001_game1/audio/z1c1-brawo.mp3',
  },
  checkGameText: {
    positive: 'Ćwiczenie zostało wykonane. Brawo! ',
    negative: '',
  },
  assets: {
    img: img || [],
    audio: audio || [],
    extendetJS: [],
    extendetStyle: [],
  },
};

export default config;
